/**
 * Formata um número de telefone no formato brasileiro com DDD.
 * @param {string} phoneNumber - O número de telefone a ser formatado.
 * @returns {string} O número de telefone formatado ou a entrada original se inválida.
 */
export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) return '';

  // Remove todos os caracteres não numéricos
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Verifica se o número possui código de país (exemplo: 55 para Brasil)
  const hasCountryCode = cleaned.length === 13 || cleaned.length === 12;
  const countryCode = hasCountryCode ? cleaned.slice(0, 2) : null;

  // Pega o DDD (2 primeiros dígitos após o código de país, ou do início se não tiver código de país)
  const dddStartIndex = hasCountryCode ? 2 : 0;
  const ddd = cleaned.slice(dddStartIndex, dddStartIndex + 2);

  // Captura os 8 ou 9 dígitos restantes
  const phoneDigits = cleaned.slice(dddStartIndex + 2);

  // Validação: Número deve ter pelo menos 10 dígitos (2 do DDD + 8 do telefone)
  if (phoneDigits.length < 8 || phoneDigits.length > 9) return phoneNumber;

  // Separa os blocos de números do telefone
  const firstPart =
    phoneDigits.length === 9
      ? phoneDigits.slice(0, 5)
      : phoneDigits.slice(0, 4);
  const secondPart =
    phoneDigits.length === 9 ? phoneDigits.slice(5) : phoneDigits.slice(4);

  // Retorna o número formatado corretamente
  return countryCode
    ? `+${countryCode} (${ddd}) ${firstPart}-${secondPart}`
    : `(${ddd}) ${firstPart}-${secondPart}`;
}
